<script>
import { headerEmits, headerProps, useHeader } from "./mixin";
import Cart from "./cart/default";
import AchatsExpress from "./achats-express/default";
import MonMagasin from "./mon-magasin/default";
import HeaderLight from "./light/default";
import LinkTo from "@/components/atoms/link-to";
import Popin from "@/components/molecules/popin";
import SearchBar from "@/containers/auto-suggest/auto-suggest-search-bar";
import AutoSuggest from "@/containers/auto-suggest/auto-suggest-panel";
import ButtonNavigation from "@/components/molecules/button-navigation";
import EncartPanier from "@/containers/encart-panier";
import Connexion from "@/containers/connexion";
import ConnexionRequired from "@/containers/connexion/connexion-required";
import MonCompte from "@/components/organisms/header/mon-compte";
import Menu from "@/containers/menu";
import HtmlParser from "@/components/organisms/cms-container/html-parser";
import LazyImage from "@/components/atoms/lazy-image";
import PopinViderPanier from "@/components/organisms/popins-compte/popin-vider-panier";
import coraLogoCercle from "@/assets/images/cora-logo-cercle.svg";

export default {
  name: "Header",
  components: {
    SearchBar,
    Popin,
    Menu,
    AutoSuggest,
    ButtonNavigation,
    MonMagasin,
    Cart,
    AchatsExpress,
    EncartPanier,
    Connexion,
    ConnexionRequired,
    LinkTo,
    MonCompte,
    HtmlParser,
    HeaderLight,
    LazyImage,
    PopinViderPanier
  },
  props: {
    value: {
      type: String,
      default: ""
    },
    ...headerProps()
  },
  // provoque un bug lié au HeaderLight
  // emits: [
  //   "askAuth",
  //   "closePanel",
  //   "openOrcloseStoreLocator",
  //   "openPlanningPopin",
  //   "setEncartPanierVisible",
  //   ...headerEmits()
  // ],
  data() {
    return {
      showAutoSuggest: false
    };
  },
  methods: {
    hideMenu() {
      this.$refs.menu.hide();
    },
    askAuth() {
      this.$emit("askAuth");
    },
    closeAndLogout() {
      this.$refs.monCompte.close();
      this.logout();
    }
  },
  setup(props, context) {
    const header = ref(null);
    const popinEncartPanier = ref(null);
    const confirmClear = ref(null);

    const {
      isSticky,
      typePanierToDelete,
      isHomePage,
      defaultHeaderMerchHtmlContent,
      miamPushZone,
      logout,
      showPopinViderPanier,
      mounted,
      beforeUnmount
    } = useHeader(props, context, header, popinEncartPanier, confirmClear);

    onBeforeUnmount(beforeUnmount);

    onMounted(mounted);

    return {
      header,
      popinEncartPanier,
      confirmClear,
      isSticky,
      typePanierToDelete,
      isHomePage,
      defaultHeaderMerchHtmlContent,
      logout,
      showPopinViderPanier,
      coraLogoCercle,
      miamPushZone
    };
  }
};
</script>

<template>
  <div>
    <header
      ref="header"
      class="c-header Desk_Header"
      role="banner"
    >
      <div class="c-header__top">
        <div
          class="c-header__logo-wrapper"
          @click="$emit('closePanel')"
        >
          <h1 class="c-header__logo-title">
            <LinkTo
              to="/"
              :aria-current="null"
              class="c-header__logo-link"
            >
              <LazyImage
                :src="coraLogoCercle"
                class="c-header__logo u-mb-xxs u-mb-none@md10"
                alt="Cora devient Carrefour - Magasins, Drive, Livraison, Retrait"
                width="71"
                height="59"
              />
            </LinkTo>
          </h1>
        </div>

        <SearchBar
          class="c-header__search-bar"
          @focus="showAutoSuggest = true"
          @reset="showAutoSuggest = false"
        />
        <ClientOnly>
          <div
            v-show="showAutoSuggest && !isSticky"
            class="c-header__auto-suggest-wrapper"
          >
            <AutoSuggest
              class="c-header__auto-suggest"
              :is-open="showAutoSuggest"
              @closePanel="showAutoSuggest = false"
            />
          </div>
        </ClientOnly>
        <div
          class="c-header__navigation"
          @click="$emit('closePanel')"
        >
          <ButtonNavigation
            ref="findShop"
            :notification-available="!isNational"
            icon-name="shop"
            icon-color="primary"
            icon-size="md"
            open-on-hover
            class="c-header__button-navigation--shop"
            :class="{ 'c-header__button-navigation': !isNational }"
            @mouseover="$refreshShopData()"
          >
            <template
              v-if="!isNational"
              #button-content
            >
              <span class="u-none@md50 c-header-shop__online u-block u-mt-xs">
                Mon magasin
                <br />
                <span class="u-text-center">{{ shopName }}</span>
              </span>
            </template>
            <template
              v-else
              #button-content
            >
              <span class="u-mt-xs u-block u-none@lg100 u-text-center">
                Sélectionnez votre magasin<br />ou votre point de retrait
              </span>
              <span class="u-mt-xs u-none u-block@lg100 u-none@md50 u-text-center">
                Votre magasin
              </span>
            </template>
            <MonMagasin
              :is-national="isNational"
              :shop-name="shopName"
              :shop-phone="shopPhone"
              :shop-city="shopCity"
              :shop-zip-code="shopZipCode"
              :shop-address="shopAddress"
              :shopfirst-slot-available="shopfirstSlotAvailable"
              :shop-id="shopId"
              :web-alias="webAlias"
              :magasin="magasin"
              :is-pro="customer && customer.attributes.pro"
              @selectShopClicked="$emit('openOrcloseStoreLocator')"
              @openPlanningPopin="$emit('openPlanningPopin')"
            />
          </ButtonNavigation>
          <ButtonNavigation
            icon-name="prospectus"
            :to="'/prospectus'"
            class="c-header__button-navigation"
            icon-color="primary"
            icon-size="md"
          >
            <template #button-content>
              <span class="u-block u-none@md50 u-mt-xs u-text-center">
                Prospectus
              </span>
            </template>
          </ButtonNavigation>
          <ButtonNavigation
            icon-name="mes-listes"
            class="c-header__button-navigation"
            icon-color="primary"
            icon-size="md"
            open-on-hover
          >
            <template #button-content>
              <span class="u-mt-xs u-none u-block@lg100 u-none@md50 u-text-center">Mes listes</span>
              <span class="u-mt-xs u-block u-none@lg100  u-text-center">
                Mes listes<br />de courses
              </span>
            </template>
            <client-only v-if="customer === null">
              <AchatsExpress />
            </client-only>
            <AchatsExpress v-else />
          </ButtonNavigation>
          <ButtonNavigation
            v-if="!(customer && customer.attributes.pro)"
            icon-name="cora-card"
            icon-color="primary"
            icon-size="md"
            :to="customer ? '/mon-compte/ma-fidelite' : '/accueil-fidelite'"
            class="c-header__button-navigation"
          >
            <template #button-content>
              <span class="u-block u-none@md50 u-mt-xs u-text-center">Ma fidélité</span>
            </template>
          </ButtonNavigation>
          <ButtonNavigation
            ref="monCompte"
            :notification-available="customer !== null"
            icon-name="user-outline"
            class="c-header__button-navigation"
            icon-color="primary"
            icon-size="md"
            open-on-hover
            :aria-haspopup="customer === null"
            @click="askAuth()"
          >
            <template #button-content>
              <span
                v-if="customer !== null"
                class="u-none@md50 u-block u-mt-xs"
              >{{ customer.attributes.prenom }}</span>
              <span
                v-else
                class="u-block u-none@md50 u-mt-xs"
              >Mon compte</span>
            </template>
            <MonCompte
              v-if="customer !== null"
              :first-name="customer.attributes.prenom"
              :is-pro="customer.attributes.pro"
              @logout="closeAndLogout"
            />
          </ButtonNavigation>
        </div>
        <Cart
          class="u-ml-md"
          :total="montantTotalTTC"
          :is-loading="isPanierLoading"
          @click="$emit('setEncartPanierVisible', true)"
        />
        <Popin
          ref="popinEncartPanier"
          close-on-route-change
          size="md"
          side-bar
          side-bar-offset="md"
          aria-label="Panier"
          :visible="encartPanierVisible"
          @hidden="$emit('setEncartPanierVisible', false)"
        >
          <EncartPanier
            ref="encartPanier"
            @showPopinViderPanier="showPopinViderPanier"
          />
        </Popin>
        <PopinViderPanier
          ref="confirmClear"
          :type-panier="typePanierToDelete"
          @validate="$refs.encartPanier.notifyAndClear(typePanierToDelete)"
        />
      </div>
      <div
        v-if="showAutoSuggest"
        class="c-header__auto-suggest-overlay"
        @click="showAutoSuggest = false"
      />
    </header>
    <Menu
      ref="menu"
      class="c-header__menu Desk_Menu"
      :miam-push-zone="miamPushZone"
      :is-home-page="isHomePage"
    />
    <ClientOnly>
      <HtmlParser
        v-if="defaultHeaderMerchHtmlContent"
        :promo-printing="true"
        context="toutes les pages"
        :push-data="defaultHeaderMerchHtmlContent"
      />
    </ClientOnly>
    <Connexion />
    <ConnexionRequired />
    <ClientOnly>
      <transition name="header-sticky">
        <HeaderLight
          v-if="isSticky"
          v-bind="{ ...$props, ...extractListenersFromAttrs($attrs) }"
          :show-auto-suggest="showAutoSuggest"
          :miam-push-zone="miamPushZone"
          @autosuggestShown="showAutoSuggest = true"
          @autosuggestClosed="showAutoSuggest = false"
        />
      </transition>
    </ClientOnly>
  </div>
</template>
<style lang="scss" scoped>
@import "@/assets/styles/components/header.scss";
</style>
